export const dateMenuItems = [
  'Select Date',
  'Last 7 Days',
  'Last 30 Days',
  'Last 3 Months',
  'Custom Range',
];

export const gatewayMenuItems = ['BILLDESK V1', 'BILLDESK V2', 'CAMS Pay', 'RAZORPAY', 'CASHFREE', 'EPAY'];
